<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12 component-title-row">
          <h3><i class="fa fa-fw fa-male"></i> {{ _('Customers') }}</h3>
          <div class="component-title-buttons">
            <button class="newSelector btn btn-success addbutton" type="button" v-on:click.stop="createNewDialog"><i class="fa fa-fw fa-plus"></i><span class="hidden-xs"> {{ _('Create new...') }}</span></button>
          </div>
        </div>
      </div>
      <div class="list-filter-row">
        <div class="list-filter-col filtercol">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
              <span class="input-group-btn">
                <button type="button" :class="'btn btn-success' + (listFilterVisible ? ' active' : '')" :title="(listFilterVisible ? 'Piilota rajaimet' : 'Näytä rajaimet')" @click="listFilterVisible = !listFilterVisible"><i :class="'fa fa-fw ' + (listFilterVisible ? 'fa-caret-up' : 'fa-sliders')"></i></button>
              </span>
            </div>
          </div>
        </div>
        <div v-if="listFilterVisible" class="list-filter-col button-col filtercol">
          <button class="btn btn-success" type="button" v-on:click="downloadXlsx"><i class="fa fa-fw fa-download"></i> {{ _('Download Excel file') }}</button>
        </div>
      </div>
      <Datatable :url="customerUrl" :search="search" :options="tableOptions" ref="datatable" v-on:data="tableEvent" />
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
// import Datatable from '~/components/Datatable'
import debounce from 'lodash/debounce'

export default defineNuxtComponent({
  data () {
    let $this = this
    const _ = useNuxtApp().$translate
    return {
      customers: [],
      search: '',
      tableOptions: {
        responsiveLayoutCollapseFormatter: this.collapseFormatter(),
        columns: [{
          title: 'ID',
          field: 'id',
          width: 60,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 5,
          responsive: 0
        },
        {
          title: _('City'),
          field: 'city',
          widthGrow: 4
        },
        {
          title: _('Phone'),
          field: 'phone',
          widthGrow: 5
        },
        {
          title: _('Email'),
          field: 'email',
          widthGrow: 4
        }
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editCustomer(id, name)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    customerUrl () {
      return this.baseDomain + this.shopId + '/customers.json?apikey=' + this.apiKey
    }
  },
  methods: {
    downloadXlsx () {
      const filters = []
      if (this.search) {
        filters.push({ field: 'search', type: 'like', value: this.search })
      }
      let filterStr = ''
      if (filters.length) {
        filterStr = '&filters[]=' + filters.map(f => JSON.stringify(f)).join('&filters[]=')
      }
      window.open(this.baseDomain + this.shopId + '/customers.xlsx?apikey=' + this.apiKey + filterStr)
    },
    editCustomer (id, name, activeTab, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'CustomerDetails',
        title: this._('Customer') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          customerId: id,
          activeTab
        },
        skipState
      })
    },
    createNewDialog () {
      this.showDialog({
        title: this._('Create new...'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name'],
            handler: this.createNew
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name'
          }
        ]
      })
    },
    async createNew (data) {
      let response
      let d = {
        name: data.name
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/customers.json?apikey=' + this.apiKey, d)
        if (response.data) {
          this.editCustomer(response.data, data.name, 'general')
        }
      } catch(e) {
        this.showError(e)
      }
    },
    reload () {
      this.$refs.datatable.reload()
    }
  },
  watch: {
    listFilterVisible () {
      this.$refs.datatable.resize()
    }
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['customerUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      events['restoreDetails'] = (message) => {
        if (message.shopId !== this.shopId) {
          return
        }
        switch(message.component) {
          case 'CustomerDetails':
            this.editCustomer(message.data.customerId, null, null, true)
            break
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }

})

</script>